export class Address {
  id: number;
  state: string;
  city: string;
  zipCode: string;
  description: string;
}
